// React Query hooks para bookings (NABU-71).

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { bookingsApi } from '../api';
import type { BookingsListFilters } from '../types';

const KEY = 'bookings-1to1';

export const useBookingProfiles = () =>
  useQuery({
    queryKey: [KEY, 'profiles'],
    queryFn: () => bookingsApi.listProfiles(),
  });

export const useBookingServices = (profileId?: number) =>
  useQuery({
    queryKey: [KEY, 'services', profileId ?? null],
    queryFn: () => bookingsApi.listServices(profileId),
  });

export const useAvailability = (profileId: number | null) =>
  useQuery({
    queryKey: [KEY, 'availability', profileId ?? null],
    queryFn: () => bookingsApi.listAvailability(profileId as number),
    enabled: profileId !== null && profileId !== undefined,
  });

export const useBookings = (filters: BookingsListFilters = {}) =>
  useQuery({
    queryKey: [KEY, 'list', filters],
    queryFn: () => bookingsApi.list(filters),
  });

export const useMarkCompleted = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => bookingsApi.markCompleted(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [KEY, 'list'] });
    },
  });
};

export const useCancelBooking = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason?: string }) =>
      bookingsApi.cancel(id, reason || ''),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [KEY, 'list'] });
    },
  });
};
